import React from "react";
import { useLocation } from "react-router-dom";
import { CheckInShell, Icon } from "../../components/CheckInDesign";
import { getPreferredIdUploadLanguage } from "../../components/languagePreference";
import { getLocalizedErrorCopy } from "../../components/userFacingErrors";

export default function PageNotFound() {
  const lang = getPreferredIdUploadLanguage();
  const it = lang === "it";
  const location = useLocation();
  const isReservationNotFound = location.state?.reason === "reservation_not_found";
  const reservationCopy = getLocalizedErrorCopy("reservation_not_found", lang);

  return (
    <CheckInShell>
      <div className="v0-card-scroll">
        <div className="v0-not-found-panel">
          <div className="v0-not-found-badge" aria-hidden>
            <Icon name="alert" size={28} />
          </div>
          <div className="v0-hero-copy v0-not-found-copy">
            <h1>
              {isReservationNotFound
                ? reservationCopy.title
                : it
                  ? "Pagina non trovata"
                  : "Page not found"}
            </h1>
            <p>
              {isReservationNotFound
                ? reservationCopy.body
                : it
                  ? "Il link potrebbe essere incompleto o non più valido."
                  : "The link may be incomplete or no longer valid."}
            </p>
          </div>
        </div>
      </div>
    </CheckInShell>
  );
}
